module.exports = __webpack_public_path__ + "img/sucesiones.e764aabe.png";